
import React from 'react';
import { ExportHistory } from './ExportHistory';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card } from '@/components/ui/card';

export function ArchivesTabContent() {
  return (
    <Tabs defaultValue="archived" className="space-y-4">
      <TabsList>
        <TabsTrigger value="archived">Archived Certificates</TabsTrigger>
        <TabsTrigger value="exports">Export History</TabsTrigger>
      </TabsList>
      
      <TabsContent value="archived">
        <Card>
          {/* This will be implemented later as part of the archives management system */}
          <div className="p-6 text-center text-muted-foreground">
            <p>Archived certificates will appear here.</p>
            <p className="text-sm mt-2">
              When records exceed their retention period, they are moved to the archives
              before permanent deletion.
            </p>
          </div>
        </Card>
      </TabsContent>
      
      <TabsContent value="exports">
        <ExportHistory />
      </TabsContent>
    </Tabs>
  );
}
